import React from "react";
import AgentAgreementSignPanel from "./AgentAgreementSignPanel.js";

const AgentAgreementSigningModal = ({
  contactId,
  profile,
  paperworkId,
  onSigned,
}) => {
  return (
    <div
      className="modal show"
      role="dialog"
      style={{ display: "block", backgroundColor: "rgba(0, 0, 0, 0.5)" }}
      data-backdrop="static"
      data-keyboard="false"
    >
      <div
        className="modal-dialog modal-xl modal-dialog-scrollable agent-agreement-modal"
        role="document"
        style={{ maxWidth: "1400px", width: "96vw" }}
      >
        <div className="modal-content">
          <div className="modal-header">
            <h4 className="modal-title">New Broker/Agent Agreement Required</h4>
          </div>
          <div className="modal-body fs-lg">
            <AgentAgreementSignPanel
              contactId={contactId}
              profile={profile}
              paperworkId={paperworkId}
              onSigned={onSigned}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AgentAgreementSigningModal;
